import { c } from "./colors";
import { Frame, type IllustrationProps } from "./Frame";

const STRIPES = [0, 1, 2, 3, 4] as const;

export function StoreIllustration(props: IllustrationProps) {
  return (
    <Frame {...props}>
      <rect
        x="38"
        y="62"
        width="84"
        height="70"
        rx="4"
        fill={c.n0}
        stroke={c.p200}
        strokeWidth="2"
      />
      <rect
        x="46"
        y="88"
        width="16"
        height="20"
        rx="3"
        fill={c.p100}
        stroke={c.p200}
        strokeWidth="2"
      />
      <rect
        x="98"
        y="88"
        width="16"
        height="20"
        rx="3"
        fill={c.p100}
        stroke={c.p200}
        strokeWidth="2"
      />
      <rect x="68" y="92" width="24" height="40" rx="4" fill={c.p300} />
      {STRIPES.map((i) => (
        <path
          key={i}
          d={`M${30 + 20 * i} 44h20v22a10 10 0 0 1-20 0z`}
          fill={i % 2 === 0 ? c.p500 : c.a300}
        />
      ))}
      <rect x="34" y="36" width="92" height="10" rx="5" fill={c.p700} />
    </Frame>
  );
}
